// FILECONTENT_START src/common/components/DataGrid/toolbar-buttons/DataGridToolbarWrapTextButton.tsx
import WrapTextIcon from "@mui/icons-material/WrapText";
import { Badge, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import I18n from "i18n-js";
import { DataGridToolbarProps } from "../DataGridToolbar";
import DataGridToolbarButtonContainer from "./DatagridToolbarButtonContainer";

interface DataGridToolbarWrapTextButtonProps extends DataGridToolbarProps {}

export default function DataGridToolbarWrapTextButton({
  buttonSize,
  wrapCellText,
  setWrapCellText,
}: DataGridToolbarWrapTextButtonProps) {
  return (
    <DataGridToolbarButtonContainer>
      <Tooltip
        title={I18n.t(wrapCellText ? "App.hideLongText" : "App.showLongText")}
      >
        <IconButton
          color={wrapCellText ? "primary" : "default"}
          onClick={() => setWrapCellText && setWrapCellText(!wrapCellText)}
          size={buttonSize}
        >
          <Badge
            badgeContent={wrapCellText ? 1 : 0}
            variant="dot"
            color="primary"
          >
            <WrapTextIcon fontSize={buttonSize} />
          </Badge>
        </IconButton>
      </Tooltip>
    </DataGridToolbarButtonContainer>
  );
}

// FILECONTENT_END src/common/components/DataGrid/toolbar-buttons/DataGridToolbarWrapTextButton.tsx